import { cn } from "@productlane/lib/src/cn"
import { Badge } from "@productlane/ui"

import type { ThreadTab } from "../helpers/use-inbox-tabs"
import { pressToActivate } from "@/lib/press-to-navigate"
import { getFormattedThreadCount } from "../useThreadCount"
import {
	INBOX_NAV_COUNT,
	INBOX_NAV_ICON,
	INBOX_NAV_LEAD,
	INBOX_NAV_ROW,
	INBOX_NAV_ROW_ACTIVE,
	INBOX_NAV_ROW_INACTIVE,
	INBOX_NAV_ROW_MOBILE,
} from "./inbox-nav-styles"

export const InboxTabButton = ({
	tab,
	isActive,
	onSelect,
}: {
	tab: ThreadTab
	isActive: boolean
	onSelect: () => void
}) => (
	<button
		type="button"
		{...pressToActivate(onSelect)}
		className={cn(
			INBOX_NAV_ROW,
			INBOX_NAV_ROW_MOBILE,
			isActive ? INBOX_NAV_ROW_ACTIVE : INBOX_NAV_ROW_INACTIVE,
		)}
	>
		<div className={INBOX_NAV_LEAD}>
			<tab.icon
				strokeWidth={1.25}
				className={cn(INBOX_NAV_ICON, {
					"text-red-500": tab.value === "sla-breached",
				})}
			/>
			<span className="truncate">{tab.label}</span>
		</div>
		{tab.count !== undefined && tab.count > 0 && (
			<Badge variant="transparent" size="xs" className={INBOX_NAV_COUNT}>
				{getFormattedThreadCount(tab.count)}
			</Badge>
		)}
	</button>
)
